export const deepArrayClone = <T>(arrObj: T[]): T[] => arrObj.map((obj) => ({ ...obj }));

export const camelCaseToKebabCase = (text: string) => text.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
